import Tooltip from "@/v2-ui/tooltip"
import InvitationLogStatus from "@/v2-backoffice-client/invitation/log/InvitationLogStatus"
import InvitationLogList from "@/v2-backoffice-client/invitation/log/InvitationLogList"
import type { InvitationLogFragment } from "@/v2-backoffice-client/invitation/log/__types__/invitation.log.fragment"

export type InvitationLogPopoverProps = {
  latestLog: InvitationLogFragment | null | undefined
  logs: InvitationLogFragment[]
}

function InvitationLogPopover(props: InvitationLogPopoverProps) {
  const { latestLog, logs } = props

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <InvitationLogStatus log={latestLog} />
      </Tooltip.Trigger>

      <Tooltip.Content
        className="invitation-log-popover ui-tooltip-content--panel"
        align="center"
        side="top"
      >
        <div className="invitation-log-header">Activity log</div>
        <InvitationLogList logs={logs} />
      </Tooltip.Content>
    </Tooltip>
  )
}

export default InvitationLogPopover
